import * as R from 'ramda';

const REF_AREA_ROLES = new Set(['GEO', 'REF_AREA']);
const REF_AREA_IDS = new Set(['REF_AREA', 'COUNTRY', 'LOCATION', 'REGION', 'REFERENCE_AREA']);
export const isRefAreaDimension = (dimension = {}) =>
  REF_AREA_ROLES.has(dimension.role) || REF_AREA_IDS.has(dimension.id);
export const getRefAreaDimension = dimensions => R.find(isRefAreaDimension, dimensions);

const FREQ_DIM_IDS = new Set(['FREQ', 'FREQUENCY']);
export const isFrequencyDimension = (dimension = {}) =>
  dimension.role === 'FREQ' || FREQ_DIM_IDS.has(dimension.id);
export const isFrequencyAttribute = attr => R.prop('id', attr) === 'TIME_FORMAT';

export const isTimePeriodDimension = (dimension = {}) =>
  dimension.role === 'TIME_PERIOD' || dimension.id === 'TIME_PERIOD';
export const getTimePeriodDimension = dimensions => R.find(isTimePeriodDimension, dimensions);

export const parseDisplay = display =>
  R.isNil(display) || !R.includes(display, ['both', 'code']) ? 'label' : display;

export const dimensionValueDisplay =
  (display, accessors = {}) =>
  dimensionValue => {
    const id = R.propOr('', accessors.id || 'id', dimensionValue);
    const name = R.propOr('', accessors.name || 'name', dimensionValue);
    // a non-coded component (dim | attr) has no name, names nor label
    // the only valid thing to display is the id
    if (R.propOr(false, 'isNonCoded', dimensionValue)) return id;
    //auto-generated flags have no id nor name
    if (R.isEmpty(id) && R.isEmpty(name)) return '';
    switch (display) {
      case 'label':
        return R.isEmpty(name) ? `[${id}]` : name;
      case 'code':
        return id;
      case 'both':
        if (R.isNil(id) || R.isEmpty(id)) return name;
        return `(${id}) ${name}`;
      default:
        return null;
    }
  };

export const dimensionValueDisplayAt = (dimension, index, display) => {
  const dimensionValue = R.pathOr({}, ['values', Number(index)], dimension);
  return dimensionValueDisplay(display)(dimensionValue);
};

export const categoryDisplay = (
  splitObservationKey,
  dimensions,
  dimensionsWithValuesIndexedById,
  rejectedId,
  display,
) => {
  return R.pipe(
    R.addIndex(R.reduce)((acc, dimensionValueIndex, dimensionIndex) => {
      const dimension = R.nth(dimensionIndex, dimensions) || {};
      if (R.has(dimension.id, dimensionsWithValuesIndexedById) && dimension.id !== rejectedId) {
        return R.append(dimensionValueDisplayAt(dimension, dimensionValueIndex, display), acc);
      }
      return acc;
    }, []),
    R.join(' - '),
  )(splitObservationKey);
};
